/**
 * Note that this is IE-only plugin!
 */

import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const flexToFullSizePlugin = function () {
	let containerWin;
	let iframe;

	/* This is a simplified resize function, As we're using table layout we only need to retrieve the size of a parent div*/
	const resizeEditor = function () {
		const iframeContainer = $('#wysiwyg').is(':hidden') ? $('#preview') : $('#wysiwyg');
		iframe = iframeContainer.find('iframe');
		const $headerPrecursor = $('#header-precursor');

		const windowHeight = $(window).height();
		let headerHeight =
			$headerPrecursor.offset().top + $headerPrecursor.height() + $('#header').height();
		$('#content.edit').height(windowHeight - headerHeight);

		// Ensure that the iframe resizes _after_ the container is resized.
		setTimeout(() => {
			if ($('#preview').is(':hidden')) {
				iframe.height(0).height(iframeContainer.height());
			} else {
				$('#content.edit').height('auto');
				const footerHeight = $('#savebar-container').height();

				headerHeight += $('#editor-precursor').height();

				//HACK - CONF41 BN The bottom of the preview iframe is off by this much (no idea why).
				const magicNumber = 4;
				iframe.height(windowHeight - headerHeight - footerHeight - magicNumber);
			}
		}, 1);
	};

	return {
		init(ed) {
			ed.on('Init', () => {
				let editorWin;
				let containerDoc;

				$(ed.getBody()).addClass('fullsize');

				const env = window.tinymce.Env;

				//This plugin is only used for IE/Opera where our 100% height solution does not work with CSS alone.
				if (env.ie || env.opera) {
					editorWin = ed.getWin();
					containerWin = $(editorWin.parent);
					containerDoc = $(editorWin.parent.document);

					/* In IE we need to ensure that scrollbars are only visible on the body
					 * when in the preview mode. That what these lines do.*/
					$('body').css({ overflow: 'hidden' });

					/* Setup the circumstances under which the resize function will be called */
					containerWin.bind('resize.resizeplugin', () => {
						resizeEditor();
					});

					/* Custom events don't bubble to the window. Fixed in jquery 1.6 http://bugs.jquery.com/ticket/8712 */
					containerDoc.bind('messageClose', () => {
						// messageClose is fired _before_ the element is removed.
						setTimeout(resizeEditor, 0);
					});

					containerDoc.bind('resize.resizeplugin', (e, data) => {
						resizeEditor(data && data.height);
					});

					containerDoc.bind('mode-changed', () => {
						resizeEditor();
					});

					ed.on('Change', () => {
						resizeEditor();
					});

					resizeEditor();
				}
			});
		},

		getInfo() {
			return {
				longname: 'flex editor to full size plugin',
				description:
					'adjusts height of editor so it always occupies the right space in between the toolbars',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: '1.0',
			};
		},
	};
};

export default function flextofullsize() {
	window.tinymce.create('tinymce.plugins.flextofullsizeplugin', flexToFullSizePlugin());
	window.tinymce.PluginManager.add('flextofullsize', window.tinymce.plugins.flextofullsizeplugin);
}
